const Settings = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Settings</h1>
      <p className="text-gray-600">Configure your account settings here...</p>
    </div>
  );
};

export default Settings;
